import { render, staticRenderFns } from "./PageAll.vue?vue&type=template&id=6ec6c289"
import script from "./PageAll.vue?vue&type=script&lang=js"
export * from "./PageAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports